module.exports = __webpack_public_path__ + "static/quantizer-884c4c6283974fbdf7508ec502be507a.png";